import { PostionalMediaActions } from '../constants'

export const registerPositionalMedia = positionalMedia => ({
    type: PostionalMediaActions.REGISTER_POSITIONAL_MEDIA,
    positionalMedia,
})

export const setPositionalMediaStatus = (id, status) => (dispatch, getState) => {
    const positionalMediaPlayer = (getState().getIn(['interactiveElements', 'positionalMediaPlayers']) || {})[id]

    if (positionalMediaPlayer) {
        dispatch({
            type: PostionalMediaActions.SET_POSITIONAL_MEDIA_STATUS,
            id,
            status,
        })
    }
}

export const setPositionalMediaProgress = (id, progress) => (dispatch, getState) => {
    const positionalMediaPlayer = (getState().getIn(['interactiveElements', 'positionalMediaPlayers']) || {})[id]

    if (positionalMediaPlayer) {
        dispatch({
            type: PostionalMediaActions.SET_POSITIONAL_MEDIA_PROGRESS,
            id,
            progress,
        })
    }
}

export const pausePositionalMediaPlayers = () => (dispatch, getState) => {
    const positionalMediaPlayers = getState().getIn(['interactiveElements', 'positionalMediaPlayers'])

    dispatch({
        type: PostionalMediaActions.PAUSING,
    })

    if (positionalMediaPlayers) {
        for (const player of Object.values(positionalMediaPlayers)) {
            player && player.isPlaying() && player.pause()
        }
    }

    dispatch({
        type: PostionalMediaActions.PAUSED,
    })
}

export const resetPositionalMedia = _ => (dispatch, getState) => {
    pausePositionalMediaPlayers()(dispatch, getState)

    dispatch({ type: PostionalMediaActions.RESET })
}

export const unregisterPositionalMedia = id => ({
    type: PostionalMediaActions.UNREGISTER_POSITIONAL_MEDIA,
    id,
})
